import {
  SHOP_LOCALE,
  SHOPWARE_BASE_URL
} from '../../utils/configure-environment';

export const ERROR_SET_IMAGE_TOO_SMALL = 'imageTooSmallSet';

export default {
  activePrintSide: 'front',
  designs: [],
  searchTerm: '',
  showNavigation: true,
  shopwareBaseUrl: SHOPWARE_BASE_URL,
  locale: SHOP_LOCALE,
  products: [],
  filters: {
    departments: [],
    categories: []
  },
  printplates: {},
  productChangeEnabled: true
};
